import { Component, Input } from '@angular/core';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';

const SAMPLE_ADDRESS = '18746';

@Component({
  selector: 'location-input-component-preview',
  templateUrl: './location-input-component-preview.component.html',
  styleUrls: ['./location-input-component-preview.component.scss'],
  standalone: false,
})
export class LocationInputComponentPreviewComponent {
  @Input() options: ShopPlugin.ProductPagePromise.LocationInputOptions;
  @Input() zipCodeAvailable = true;

  get sampleAddress(): string {
    return SAMPLE_ADDRESS;
  }
}
